/* tslint:disable */

// https://tc39.github.io/ecma402/#sup-array.prototype.tolocalestring
if (!Array.prototype.toLocaleString) {
    Object.defineProperty(Array.prototype, 'toLocaleString', {
        value: function(locales: any, options: any) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var a = Object(this);

            // 2. Let len be ? ToLength(? Get(A, "length")).
            var len = a.length >>> 0;

            // 3. Let separator be the String value for the
            //    list-separator String appropriate for the
            //    host environment's current locale (this is
            //    derived in an implementation-defined way).
            // NOTE: In this case, we will use a comma
            var separator = ',';

            // 4. If len is zero, return the empty String.
            if (len === 0) {
                return '';
            }

            // 5. Let firstElement be ? Get(A, "0").
            var firstElement = a[0];
            // 6. If firstElement is undefined or null, then
            //  a.Let R be the empty String.
            // 7. Else,
            //  a. Let R be ?
            //     ToString(?
            //       Invoke(
            //        firstElement,
            //        "toLocaleString",
            //        « locales, options »
            //       )
            //     )
            var r = firstElement == null ? '' : firstElement.toLocaleString(locales, options);

            // 8. Let k be 1.
            var k = 1;

            // 9. Repeat, while k < len
            while (k < len) {
                // a. Let S be a String value produced by
                //   concatenating R and separator.
                var s = r + separator;

                // b. Let nextElement be ? Get(A, ToString(k)).
                var nextElement = a[k];

                // c. If nextElement is undefined or null, then
                //   i. Let R be the empty String.
                // d. Else,
                //   i. Let R be ?
                //     ToString(?
                //       Invoke(
                //        nextElement,
                //        "toLocaleString",
                //        « locales, options »
                //       )
                //     )
                r = nextElement == null ? '' : nextElement.toLocaleString(locales, options);

                // e. Let R be a String value produced by
                //   concatenating S and R.
                r = s + r;

                // f. Increase k by 1.
                k++;
            }

            // 10. Return R.
            return r;
        },
    });
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
 */
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(searchElement: any, fromIndex: any) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x: any, y: any) {
                return (
                    x === y ||
                    (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
                );
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        },
    });
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */
(function() {
    if (typeof (window as any).CustomEvent === 'function') return;

    function CustomEvent(event: any, params: any) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = (window as any).Event.prototype;

    (window as any).CustomEvent = CustomEvent;
})();



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/util/polyfills.ts